import styled from "@emotion/styled";
import UI from "@mile-meeting/mile-ui";
import { filter } from "lodash";

export const getMinutesSince7AM = () => {
  const now = new Date();
  const sevenAM = new Date();
  sevenAM.setHours(7, 0, 0, 0);

  if (now < sevenAM || now.getHours() >= 23) {
    return 0;
  }

  const diffInMilliseconds = now.getTime() - sevenAM.getTime();
  const diffInMinutes = Math.floor(diffInMilliseconds / (1000 * 60));

  return diffInMinutes;
};

const TimeTableUnderLayout = ({ filteredDate = new Date() }: { filteredDate?: Date }) => {
  const time = [7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23];

  const overlayHeight = () => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    filteredDate.setHours(0, 0, 0, 0);

    if (filteredDate.getTime() < today.getTime()) {
      return 0.933 * 16 * 60;
    } else if (filteredDate.getTime() === today.getTime()) {
      return 0.933 * getMinutesSince7AM();
    } else {
      return 0.933 * 0;
    }
  };

  return (
    <Container>
      <Rectangle height={overlayHeight()} />
      {time.map((hour, index) => (
        <TimeRow key={index}>
          <Line />
        </TimeRow>
      ))}
    </Container>
  );
};

export default TimeTableUnderLayout;

const Rectangle = styled.div<{ height: number }>`
  width: 100%;
  box-sizing: border-box;
  position: absolute;
  height: ${(props) => props.height}px;
  pointer-events: none;
  top: 8px;
  background-color: var(--component-color-fill-alternative);
  border-bottom: 2px solid var(--alias-color-label-neutral);
`;

const Container = styled.div`
  overflow: visible;
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 40px;
  width: 100%;
  box-sizing: border-box;
  z-index: -1;
`;

const TimeRow = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  gap: 24px;
  align-self: stretch;
  height: 16px;
`;

const Line = styled.div`
  width: 100%;
  height: 1px;
  background-color: var(--alias-color-line-normal);
`;
